__webpack_require__.p = "/slack-integration-refactor/referrals-hub/";